import { Component, Input, ViewChild, ViewRef } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { ViewController, NavParams, NavController, Platform, Slides } from "ionic-angular";
import { TournamentService } from "../../../../gamer/services/tournament.service";
import { IActivity, LineUpService, TshirtType } from "../../../services/lineup-service";
import { activities } from "../../../services/lineup-service";

@Component({
    selector: "toolbar-settings",
    templateUrl: "toolbar-settings.html"
})
export class SettingsComponent {
    activeTeam: number = 0;
    activePlan: number = 0;
    activeTshirtType: TshirtType = TshirtType.tshirt;
    headerCss: boolean = false;
    activities = activities;
    $activity;
    autoSliding: boolean = false;

    @ViewChild('slides') slider: Slides;

    constructor(
        private viewCtrl: ViewController,
        private navParams: NavParams,
        public ls: LineUpService,
        private navCtrl: NavController,
        public gs: TournamentService,
        private platform: Platform,
        public translate: TranslateService
    ) {
        this.uiAdopter();
    }

    uiAdopter() {
        if (this.platform.is('ios')) {
            this.headerCss = true;
        }
    }

    ionViewDidLoad() {
        this.activeTeam = this.navParams.get('activeTeam');
        this.activePlan = this.navParams.get('activePlan');
        this.$activity = this.ls.field.activity;
        this.activeTshirtType = this.ls.field.type;
        setTimeout(() => {
            this.autoSliding = true;
        }, 200);
    }

    clickTest(activeTshirtType, i){
        console.log('a=' + activeTshirtType + ', i=' + i)
    }

    slideChange(event) {
        console.log('event: ', event);
        if(this.autoSliding){
            let i = this.slider.getActiveIndex();
            console.log('i: ', i - 2);
            console.log(this.types[this.filter(i - 2)]);
            this.activeTshirtType = this.ls.field.type = this.filter(this.slider.getActiveIndex() - 2);
            console.log('this.activeTshirtType: ', this.activeTshirtType);
            this.ls.save();
        }
    }

    filter(n: number){
        switch(n){
            case -2: return 7;
            case 10: return 1;
            default:
            return n;
        }
    }

    onWindowClose() {
        this.gs.setActivity(this.$activity, this.activePlan, this.activeTeam);
        this.ls.field.activity = this.$activity;
        this.ls.save();
        this.ls.saveDisplayConfigs();
        this.ls.updateSub.next();
        this.navCtrl.pop();
    }

    onThreeChange() {
        document.documentElement.style.setProperty('--threeD', this.ls.field.threeD ? "45deg" : "0");
        this.ls.updateSub.next();
    }

    types = [
        this.translate.instant('bandedcollar'),
        this.translate.instant('henley'),
        this.translate.instant('hoodie'),
        this.translate.instant('longsleeves'),
        this.translate.instant('nosleeves'),
        this.translate.instant('polo'),
        this.translate.instant('shirt'),
        this.translate.instant('tshirt'),
        this.translate.instant('vneck')
    ]
}


// WEBPACK FOOTER //
// /src/pages/apps/lineup/components/toolbar/settings/toolbar-settings.ts